<template>
    <div>

        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <button type="button" class="btn btn-info"
                        @click="printMultiBilling"
                        :disabled="checkbox_id.length < 1">
                    <icon name="print"></icon>
                    พิมพ์ใบวางบิลหลายใบ
                </button>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">
                        <input type="checkbox" v-model="selectAll" v-if="search.seller_id"/>
                    </th>
                    <th scope="col">พิมพ์</th>
                    <th scope="col">เซลล์</th>
                    <th scope="col">ลูกค้า</th>
                    <th scope="col">เลขใบวางบิล</th>
                    <th scope="col">เลขที่บิลขาย</th>
                    <th scope="col">ยอดเงิน</th>
                    <th scope="col">ยอดเงินค้างชำระ</th>
                    <th scope="col">วันที่วางบิล</th>
                    <th scope="col">กำหนดชำระ</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">ผู้รับบิล/ใบวางบิล</th>
                    <th scope="col" v-if="!checkCancel() && !checkAll() && !checkPaymentSuccess() && canViewSuperAdmin">
                        ยกเลิก
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(billing, index) in billings">
                    <th scope="col" style="vertical-align: top">
                        <input type="checkbox" :value="billing" v-model="checkbox_id"/>
                    </th>
                    <td>
                        <a :href="domain + billing.id" target="_blank" class="btn btn-primary">
                            พิมพ์
                        </a>
                    </td>
                    <td>{{ billing.seller.name }}</td>
                    <td>
                        <template v-if="billing.customer">
                            {{billing.customer.customer_id}}
                            {{ billing.customer.store_name ? billing.customer.store_name : billing.customer.name }}
                        </template>
                    </td>
                    <td>{{ billing.no }}</td>
                    <td>
                        <template v-if="billing.details.length > 0" v-for="detail in billing.details">
                             - {{detail.invoice_number}}<br/>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ billing.total_price | currency }}</td>
                    <td>{{ billing.remaining | currency }}</td>
                    <td>{{ billing.created_at | moment("DD/MM/YYYY , H:mm:ss") }}</td>
                    <td>{{ billing.due_date | moment("DD/MM/YYYY") }}</td>
                    <td>{{ billing.status.name }}</td>
                    <td>
                        <template v-if="billing.user">
                            {{ billing.user.name }}
                        </template>
                    </td>
                    <td v-if="!checkCancel() && !checkAll() && !checkPaymentSuccess() &&canViewSuperAdmin">
                        <button class="btn btn-danger"
                                @click="showBillingById(billing.id)">
                            <icon name="pencil-alt"></icon>
                            แก้ไขข้อมูล
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="billings.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="setBillings">
            </vue-pagination>
        </div>

        <b-modal size="lg" hide-header hide-footer ref="payment_modal">
            <payment-modal @submit="submitPaymentModal">
            </payment-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <!-- ------delete------- -->
        <b-modal hide-header hide-footer ref="edit_item">
            <div class="row">
                <div class="col-4 text-right">หมายเลขใบวางบิล</div>
                <div class="col-6">
                    <input class="form-control" v-model="billing_data.billing_id" disabled/>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-4 text-right">ส่วนลด (%)</div>
                <div class="col-6">
                    <input class="form-control" v-model="billing_data.discount"/>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-4 text-right">หมายเลข TN</div>
                <div class="col-6">
                    <multiselect
                        v-model="billing_data.invoices"
                        :options="optionInvoices"
                        track-by="id"
                        label="invoice_id"
                        :multiple="true"
                        :show-labels="false"
                        placeholder="เลือก TN">
                    </multiselect>
                </div>
            </div>
            <br>
            <div style="text-align: center;">
                <button
                        type="button"
                        class="btn btn-success"
                        @click="editBilling">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click="hideEditModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <pre class="alert-warning" style="display: none">{{setCheckBox}}</pre>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import moment from "moment";
    import Multiselect from "vue-multiselect";
    import VuePagination from "../../Pagination";
    import DatePicker from 'vue2-datepicker'
    import { domain } from "../../../util/Constants";
    import Modal from "bootstrap-vue/es/components/modal/modal"
    import PaymentModal from "./PaymentModal"
    import {
        canViewSuperAdmin
    } from "../../../util/Permissions";
    import Loading from "../../Utility/Loading";

    export default {
        components: {
            Loading,
            VuePagination,
            Multiselect,
            DatePicker,
            Modal,
            PaymentModal
        },
        name: "billings",
        props: ["statusId"],
        data() {
            return {
                msg : '',
                status_loading : "",
                delete_id : "",
                checkbox_id : [],
                billing_data : {
                    id : '',
                    billing_id : '',
                    discount : '',
                    invoices : []
                },
                optionInvoices : [],
            }
        },
        created() {
            this.domain = domain+'/billing-pdf/' ;
            this.dataPaginate.current_page = 1;
            this.$store.dispatch("Billing/setBillings");
            this.$store.dispatch("Billing/clearSearch");
            this.setBillings();
        },
        computed: {
            canViewSuperAdmin,
            ...mapState({
                billings: state => {
                    return state.Billing.billings
                },
                dataPaginate:state=>{
                    return state.Billing.dataPaginate
                },
                search : state=>{
                    return state.Billing.search
                },
                select_all : state=>{
                    return state.Billing.select_all;
                }

            }),
            selectAll:{
                get:function () {
                    return this.billings ? this.checkbox_id.length >= this.billings.length : false;
                },
                set:function (value) {
                    if(value){
                        this.$store.dispatch("Billing/setSelectAll",true)
                        this.selectBillingAll();
                    }
                    else{
                        this.$store.dispatch("Billing/setSelectAll",false)
                        this.checkbox_id = [];
                    }
                }
            },
            setCheckBox(){
                if(!this.select_all){
                    this.checkbox_id = [];
                }
            }
        },
        methods: {
            showLoadingModal() {
                this.$refs.loading.show();
            },
            hideLoadingModal() {
                this.$refs.loading.hide();
            },
            showEditModal() {
                this.$refs.edit_item.show();
            },
            hideEditModal() {
                this.$refs.edit_item.hide();
            },
            setBillings() {
                this.$store.dispatch("Billing/setBillingCounts")
                    .then(() => this.$store.dispatch("Billing/setBillings"))
            },
            hidePaymentModal(){
                this.$refs.payment_modal.hide()
            },
            submitPaymentModal(submitData) {
                if(submitData) {
                    this.dataPaginate.current_page = 1;
                    this.$store.dispatch("Payment/createPayment")
                        .then(() => this.setBillings());
                    this.$router.push("/accounting/billing/billings/status/2");
                }
                this.hidePaymentModal()
            },
            cancelBilling(){
                let statusId = 4;
                return this.$store.dispatch("Billing/cancelBilling",this.delete_id)
                    .then(() => {
                        this.hideDeleteModal();
                        this.setBillings();
                        this.$store.dispatch("Billing/setStatus", statusId);
                        this.$router.push({
                            path : "/accounting/billing/billings/status/4"
                        });
                    });
            },
            editBilling(){
                let details = [];
                this.billing_data.invoices.forEach(invoice=>{

                    let data = {
                        invoice_id : invoice.id,
                        discount : 0,
                        discount_status_id : 1
                    }
                    details.push(data);
                })
                let data = {
                    discount : this.billing_data.discount,
                    details,
                }
                this.msg = 'กำลังบันทึกข้อมูล กรุณารอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("Billing/updateBilling", {
                    id : this.billing_data.id,
                    data : data
                }).then(()=>{
                    this.setBillings();
                    this.hideEditModal();
                    this.msg = 'บันทึกข้อมูลสำเร็จ';
                    this.status_loading = 2;
                }).catch(()=>{
                    this.msg = 'บันทึกข้อมูลไม่สำเร็จ';
                    this.status_loading = 3;
                });
            },
            checkCancel(){
                return this.$route.path === "/accounting/billing/billings/status/4"
            },
            checkPaymentSuccess(){
                return this.$route.path === "/accounting/billing/billings/status/2"
            },
            checkAll(){
                return this.$route.path === "/accounting/billing/billings"
            },
            showBillingById(id){
                this.$store.dispatch("Billing/showBillingById",id).then(res=>{
                    this.billing_data.id = id;
                    this.billing_data.billing_id =  res.no;
                    this.billing_data.discount = res.discount;
                    this.billing_data.invoices = res.invoices;
                    let data = {
                        customer_id : res.customer_id
                    }
                    this.$store.dispatch("Invoice/getInvoiceByCustomerId",data).then(invoice=>{
                        this.optionInvoices = invoice;
                        this.showEditModal();
                    })
                })
            },
            selectBillingAll(){
                this.msg = 'กำลังเลือกข้อมูล กรณารอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("Billing/selectBillingAll",this.search).then(res=>{
                    this.checkbox_id = res;
                    this.hideLoadingModal();
                })
            },
            printMultiBilling(){
                if(this.checkbox_id.length > 0){
                    let id = [];
                    this.checkbox_id.forEach(data=>{
                        id.push(data.id);
                    })
                    this.showLoadingModal();
                    this.status_loading = 1;
                    this.msg = 'กำลังดาวโหลดเอกสาร กรุณารอสักครู่';
                    this.$store.dispatch("Billing/printMultiBilling",id.toString()).then(url=>{
                        if(url){
                            window.open(url);
                            this.hideLoadingModal();
                        }else{
                            this.showLoadingModal();
                            this.status_loading = 3;
                            this.msg = 'ไม่มีเอกสารที่สามารถดาวโหลดได้';
                        }
                    }).catch(()=>{
                        this.showLoadingModal();
                        this.status_loading = 3;
                        this.msg = 'ดาวโหลดเอกสารไม่สำเร็จ';
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .select {
        border: 0;
    }

    table {
        tr {
            th {
                vertical-align: middle;
            }
            td, th {
                white-space: nowrap;
            }
        }
    }
</style>
